import React, { Component } from 'react';
import classNames from 'classnames';

import { formatCurrencyMajorUnit } from '../../../util/currency';
import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';

import IconPlus from '../IconPlus/IconPlus';
import PriceFilterForm from '../PriceFilterForm/PriceFilterForm';

import css from './PriceFilterPlain.module.css';

const RADIX = 10;

const getPriceQueryParamName = queryParamNames => {
  return Array.isArray(queryParamNames)
    ? queryParamNames[0]
    : typeof queryParamNames === 'string'
    ? queryParamNames
    : 'price';
};

// Parse value, which should look like "0,1000"
const parse = priceRange => {
  const [minPrice, maxPrice] = !!priceRange
    ? priceRange.split(',').map(v => Number.parseInt(v, RADIX))
    : [];

  // Note: we compare to null, because 0 as minPrice is falsy in comparisons.
  return !!priceRange && minPrice != null && maxPrice != null ? { minPrice, maxPrice } : null;
};

// Format value, which should look like { minPrice, maxPrice }
const format = (range, queryParamName) => {
  const { minPrice, maxPrice } = range || {};
  // Note: we compare to null, because 0 as minPrice is falsy in comparisons.
  const value = minPrice != null && maxPrice != null ? `${minPrice},${maxPrice}` : null;
  return { [queryParamName]: value };
};

// Format value for bounds, which should look like { bounds }
const formatBounds = (values, queryParamName) => {
  const { bounds, address, minPrice, maxPrice } = values || {};

  // Note: we compare to null, because 0 as minPrice is falsy in comparisons.
  const radius = minPrice != null ? `${minPrice}` : null;
  const priceRange = minPrice != null && maxPrice != null ? `${minPrice},${maxPrice}` : null;

  return { address, bounds, radius };
  // return { address, bounds, radius, [queryParamName]: priceRange };
};

class PriceFilterPlainComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: true };

    this.handleClear = this.handleClear.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.toggleIsOpen = this.toggleIsOpen.bind(this);
  }

  // handleChange(values) {
  //   const { onSubmit, queryParamNames } = this.props;
  //   const priceQueryParamName = getPriceQueryParamName(queryParamNames);
  //   onSubmit(format(values, priceQueryParamName));
  // }

  handleChange(values) {
    const { onSubmit, queryParamNames } = this.props;
    const priceQueryParamName = getPriceQueryParamName(queryParamNames);
    onSubmit(formatBounds(values, priceQueryParamName));
  }

  handleSubmit(values) {
    const { onSubmit, queryParamNames } = this.props;
    // this.setState({ isOpen: false });
    const priceQueryParamName = getPriceQueryParamName(queryParamNames);
    onSubmit(formatBounds(values, priceQueryParamName));
  }

  handleClear() {
    const { onSubmit, queryParamNames } = this.props;
    const priceQueryParamName = getPriceQueryParamName(queryParamNames);
    onSubmit(format(null, priceQueryParamName));
  }

  handleCancel() {
    const { onSubmit, initialValues } = this.props;
    this.setState({ isOpen: false });
    onSubmit(initialValues);
  }

  toggleIsOpen() {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  }

  render() {
    const {
      id,
      max,
      min,
      intl,
      step = 1,
      label,
      className,
      initialValues,
      rootClassName,
      queryParamNames,
      marketplaceCurrency,
    } = this.props;
    const classes = classNames(rootClassName || css.root, className);

    const priceQueryParam = getPriceQueryParamName(queryParamNames);
    const initialPrice = initialValues ? parse(initialValues[priceQueryParam]) : {};
    const { minPrice, maxPrice } = initialPrice || {};

    const hasValue = value => value != null;
    const hasInitialValues = initialValues && hasValue(minPrice) && hasValue(maxPrice);

    const labelSelection = hasInitialValues
      ? intl.formatMessage(
          { id: 'PriceFilter.labelSelectedPlain' },
          {
            minPrice: formatCurrencyMajorUnit(intl, marketplaceCurrency, minPrice),
            maxPrice: formatCurrencyMajorUnit(intl, marketplaceCurrency, maxPrice),
          }
        )
      : null;
    return (
      <div className={classes}>
        <div className={css.filterHeader}>
          <button type="button" className={css.labelButton} onClick={this.toggleIsOpen}>
            <span className={css.labelButtonContent}>
              <span className={css.labelWrapper}>
                <span className={css.label}>
                  {label}
                  {labelSelection ? (
                    <React.Fragment>
                      <span>{': '}</span>
                      <span className={css.labelSelected}>{labelSelection}</span>
                    </React.Fragment>
                  ) : null}
                </span>
              </span>

              <span className={css.openSign}>
                <IconPlus isOpen={this.state.isOpen} isSelected={hasInitialValues} />
              </span>
            </span>
          </button>
        </div>

        {/* <div className={css.formWrapper}>
          <PriceFilterForm
            id={id}
            intl={intl}
            onChange={this.handleChange}
            contentRef={node => {
              this.filterContent = node;
            }}
            initialValues={hasInitialValues ? initialPrice : { minPrice: min, maxPrice: max }}
            liveEdit
            min={min}
            max={max}
            step={step}
            isInSideBar
            isOpen={this.state.isOpen}
            style={{ minWidth: '160px' }}
          >
            <button className={css.clearButton} onClick={this.handleClear}>
              <FormattedMessage id={'PriceFilter.clear'} />
            </button>
          </PriceFilterForm>
        </div> */}

        <div className={css.formWrapper}>
          <PriceFilterForm
            id={id}
            min={min}
            max={max}
            step={step}
            intl={intl}
            isOpen={this.state.isOpen}
            onClear={this.handleClear}
            onCancel={this.handleCancel}
            onSubmit={this.handleSubmit}
            style={{ minWidth: '160px' }}
            contentRef={node => {
              this.filterContent = node;
            }}
            initialValues={hasInitialValues ? initialPrice : { minPrice: min, maxPrice: max }}
          />
        </div>
      </div>
    );
  }
}

const PriceFilterPlain = injectIntl(PriceFilterPlainComponent);

export default PriceFilterPlain;
